module.exports = __webpack_public_path__ + "media/images/categories/3-d2d61ae7f329b8683bce5d53e71284d5.png";